<header-menu [menuList]="menuList" (logoutEvent)="logout()"></header-menu>
